import { ADD_NEW_LESSONPLAN, ADD_NEW_LESSONPLAN_FAILED, ADD_NEW_LESSONPLAN_SUCCESS, GET_ADMIN_LESSONPLAN, GET_ADMIN_LESSONPLAN_FAILED, GET_ADMIN_LESSONPLAN_SUCCESS, GET_STUD_LESSONPLAN, GET_STUD_LESSONPLAN_FAILED, GET_STUD_LESSONPLAN_SUCCESS, GET_TEACHER_LESSONPLAN, GET_TEACHER_LESSONPLAN_FAILED, GET_TEACHER_LESSONPLAN_SUCCESS, UPDATE_LESSONPLAN, UPDATE_LESSONPLAN_FAILED, UPDATE_LESSONPLAN_SUCCESS } from "./Constants";

const initialState = {
  Loading: false,
  successMsg: "",
  errors: "",
  lessonPlanList: [],
  isLessonPlanCreated: false
}


const ClassWorkReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEACHER_LESSONPLAN:
    case GET_ADMIN_LESSONPLAN:
    case GET_STUD_LESSONPLAN:
      return {
        ...state,
        Loading: true,
        isLessonPlanCreated: false
      }

    case GET_TEACHER_LESSONPLAN_SUCCESS:
    case GET_ADMIN_LESSONPLAN_SUCCESS:
    case GET_STUD_LESSONPLAN_SUCCESS:
      return {
        ...state,
        Loading: false,
        lessonPlanList: action.payload
      }

    case GET_TEACHER_LESSONPLAN_FAILED:
    case GET_ADMIN_LESSONPLAN_FAILED:
    case GET_STUD_LESSONPLAN_FAILED:
      return {
        ...state,
        Loading: false,
        errors: action.payload
      }
    case ADD_NEW_LESSONPLAN:
      return {
        ...state,
        Loading: true,
        successMsg: "",
        errors: "",
      }
    case ADD_NEW_LESSONPLAN_SUCCESS:
      console.log(action.payload)
      return {
        ...state,
        Loading: false,
        successMsg: action.payload,
        isLessonPlanCreated: true
      }

    case ADD_NEW_LESSONPLAN_FAILED:
      return {
        ...state,
        Loading: false,
        errors: action.payload
      }

    case UPDATE_LESSONPLAN:
      return {
        ...state,
        Loading: true,
        successMsg: "",
        errors: "",
      }

    case UPDATE_LESSONPLAN_SUCCESS:
      return {
        ...state,
        Loading: false,
        successMsg: action.payload,
        isLessonPlanCreated: true
      }

    case UPDATE_LESSONPLAN_FAILED:
      return {
        ...state,
        Loading: false,
        errors: action.payload,
        isLessonPlanCreated: false
      }

    default:
      return state;
  }
}

export default ClassWorkReducer;